import React from 'react';

// Types
import { GoalItem } from 'Shared/constants/types';

// Hooks
import { useGoal } from 'Shared/utils/hooks/use-goal';

// Utils
import { dateMMMDDYYYY, getISOString } from 'Shared/utils/DateTime.utils';

// Components
import { WpIcon } from 'Wpds/components/icon';
import { WpDayPickerDropdown } from 'Wpds/components/day-picker';
import { WpButton } from 'Wpds/components/button';

// Styles
import './GoalDueDate.scss';

type Props = {
  goal: GoalItem;
  editable?: boolean;
};

const GoalDueDate = ({ goal, editable = false }: Props) => {
  const { canChangeStatus, handleUpdateGoal, isSaving, isComplete } = useGoal({ slug: goal.slug });

  const endDate = dateMMMDDYYYY(goal.endDate);

  const handleSaveDueDate = date => {
    handleUpdateGoal({ endDate: getISOString(date) });
  };

  const baseClassName = 'GoalDueDate';

  const CustomerInner = () => (
    <WpButton variant="tertiary" square slimPadding loading={isSaving}>
      <WpIcon name="calendar-day" size="sm" />
      {endDate}
      <WpIcon name="angle-down" />
    </WpButton>
  );

  if (canChangeStatus && editable && !isComplete) {
    return (
      <WpDayPickerDropdown
        selected={new Date(goal.endDate)}
        components={{ inner: CustomerInner }}
        onSelect={handleSaveDueDate}
        placement="bottom-end"
      />
    );
  }

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__icon`}>
        <WpIcon name="calendar-day" size="sm" />
      </div>
      {endDate}
    </div>
  );
};

export default GoalDueDate;
